import { FC } from 'react';

import PlanFeatureContent from './PlanFeatureContent';
import PlanFeatureInfo from './PlanFeatureInfo';
import { New } from './PlanFeatureInfo/Wrapper';
import {
  Columns,
  Icon,
  IconsContainer,
  PlanFeatureDescription,
  PlanFeatureText,
  PlanFeatureWrapper,
  Rows
} from './Wrapper';
import { getIconSrc } from './helpers';
import { PlanFeatureProps } from './types';
export * from './types';

const PlanFeature: FC<PlanFeatureProps> = ({ description, content, effects, iconVariant, tooltipContent }) => (
  <PlanFeatureContent {...{ effects }}>
    <PlanFeatureWrapper>
      <Icon src={getIconSrc(iconVariant)}></Icon>
      <Rows>
        <Columns>
          <PlanFeatureText>{content}</PlanFeatureText>
          <IconsContainer>
            {effects?.includes('new') && <New />}
            {tooltipContent && <PlanFeatureInfo tooltipContent={tooltipContent} />}
          </IconsContainer>
        </Columns>
        {description && <PlanFeatureDescription>{description}</PlanFeatureDescription>}
      </Rows>
    </PlanFeatureWrapper>
  </PlanFeatureContent>
);

export default PlanFeature;
